import { Divider, Grid } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import { withTranslation } from "react-i18next";
import ButtonCustom from "../../components/ButtonCustom";
import CustomTypo from "../../components/CustomTypo";
import DrawerCustom from "../../components/DrawerCustom";
import { formatDateToDDMMYYYYFrEpoch, formatDateToDDMMYYYYHHSSFrEpoch } from "../../utils/util";

const styles = theme => ({
    box: {
        padding: theme.spacing(3, 4, 3, 4),
        marginTop: theme.spacing(2),
        border: '1px solid',
        borderColor: theme.palette.border.transparent,
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(4),
        boxShadow: '1px 2px 10px -6px rgba(0,0,0,0.75)',
        cursor: 'pointer',
    }
});

function InvoicePrintOut(props) {

    const { t, classes, printOut, currency } = props;
    console.log(":printOut:",printOut);
    return (
        <DrawerCustom
            large
            open={props.open}
            onClose={props.onClose}
            title={t('account_management')}
        >
            <Grid item xs={12} className={classes.box}>
                <div dangerouslySetInnerHTML={{__html:printOut }}/>
            </Grid>
        </DrawerCustom>
    );
}

export default withStyles(styles)(withTranslation()(InvoicePrintOut));